export default __webpack_public_path__ + "static/media/IconTime.8ebcf78c.svg";